import { render, staticRenderFns } from "./_statement.vue?vue&type=template&id=7d84cdc9&lang=pug&"
import script from "./_statement.vue?vue&type=script&lang=js&"
export * from "./_statement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports